export const mockCompanyData = {
  // name: "Technical Support Solutions",
  name: "Ambrosys Tech Support",
  tagline: "Your Trusted Technical Support Partner",
  description:
    "We provide comprehensive technical support services for businesses and individuals, ensuring your technology works seamlessly 24/7.",
};

export const mockServices = [
  {
    id: 1,
    title: "IT Helpdesk Support",
    description:
      "24/7 remote assistance for all your IT issues and software problems.",
    icon: "Headphones",
  },
  {
    id: 2,
    title: "Software Support",
    description:
      "Expert troubleshooting and maintenance for all software applications.",
    icon: "Code",
  },
  {
    id: 3,
    title: "Hardware Repair",
    description:
      "Professional hardware diagnosis, repair, and replacement services.",
    icon: "Wrench",
  },
  {
    id: 4,
    title: "Tech Consulting",
    description:
      "Strategic technology guidance and digital transformation solutions.",
    icon: "Lightbulb",
  },
];

export const mockWhyChooseUs = [
  {
    id: 1,
    title: "Expert Team",
    description: "Certified professionals with 10+ years of experience",
    icon: "Users",
  },
  {
    id: 2,
    title: "24/7 Support",
    description: "Round-the-clock assistance whenever you need it",
    icon: "Clock",
  },
  {
    id: 3,
    title: "Fast Response",
    description: "Average response time under 15 minutes",
    icon: "Zap",
  },
  {
    id: 4,
    title: "Cost Effective",
    description: "Flexible pricing plans that fit your budget",
    icon: "DollarSign",
  },
];

export const mockHowItWorks = [
  {
    step: 1,
    title: "Contact Us",
    description: "Reach out via phone, email, or our online portal",
  },
  {
    step: 2,
    title: "Issue Assessment",
    description: "Our experts analyze and diagnose your technical problem",
  },
  {
    step: 3,
    title: "Solution Implementation",
    description: "We implement the best solution quickly and efficiently",
  },
  {
    step: 4,
    title: "Follow-up Support",
    description: "Ongoing monitoring to ensure everything works perfectly",
  },
];

export const mockContactInfo = {
  phone: "+91 95666 60086",
  email: "support@ambrosyscorp.com",
  address:
    " No 15, Shanthi Nagar, Kandhanchavadi, Perungudi, Chennai, Tamil Nadu 600096",
  hours: "Available 24/7 for emergency support",
};

export const mockStats = [
  { label: "Happy Clients", value: "2,500+" },
  { label: "Issues Resolved", value: "15,000+" },
  { label: "Years Experience", value: "10+" },
  { label: "Team Members", value: "50+" },
];
